import React from 'react';
import { motion } from 'framer-motion';

const ProfilePage = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="min-h-screen p-6"
    >
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-8">Your Profile</h1>
        <p className="text-lg text-slate-300 mb-8">
          Manage your account settings and track your storytelling progress.
        </p>
        
        <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
          <h2 className="text-2xl font-semibold mb-4">Profile Management</h2>
          <p className="text-slate-300">
            Profile features are currently being developed. Soon you'll be able to track your 
            progress, manage preferences, and see how your storytelling has grown.
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default ProfilePage;